import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';
import {ServicesComponent} from "../services/services.component";

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.css']
})
export class TeamComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.402;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

  showInfo(className: string) {
    $(".overlay").fadeIn(100);
    $('.' + className).fadeIn(1000);
    ServicesComponent.toTheTop();
  }

  closeInfo(){
    $(".modal-content").fadeOut(100);
    $(".overlay").fadeOut(1000);
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/about us/team.component.ts